import { Injectable, OnDestroy } from '@angular/core';
import { CacheStoragesEnum } from '../models/cache.models';
import { CacheStorageBase } from './base/cache-storage-base.service';

@Injectable()
export class CacheStorageMemory extends CacheStorageBase implements OnDestroy {
  private _data: { [key: string]: any } = {};

  // eslint-disable-next-line @angular-eslint/no-empty-lifecycle-method
  public ngOnDestroy(): void {}

  public getItem<TItem>(key: string, force?: boolean): TItem {
    return this._data[key] ? this._data[key] : null;
  }

  public setItem<TItem>(key: string, value: TItem): number | false {
    this._data[key] = value;
    return 1;
  }

  public removeItem(key: string) {
    delete this._data[key];
  }

  public clear(prefix) {
    super.clear(prefix);
    this._data = [];
  }

  public type() {
    return CacheStoragesEnum.MEMORY;
  }

  public isEnabled(check?: boolean) {
    return true;
  }

  public length() {
    return Object.keys(this._data).length;
  }

  public key(index: number) {
    const keys = Object.keys(this._data);
    return keys.length > index ? keys[index] : null;
  }

  public persist(): void {}

  public unPersist(): void {}
}
